<main class="payment">
  <div class="payment__container">
    @if (phase() === 'creating') {
      <div
        class="payment__skeleton"
        role="status"
        aria-live="polite"
        aria-label="Preparando el pago"
      >
        <span class="payment__skeleton-line payment__skeleton-line--title"></span>
        <span class="payment__skeleton-block"></span>
        <span class="payment__skeleton-line"></span>
        <span class="payment__skeleton-line payment__skeleton-line--short"></span>
      </div>
    } @else if (phase() === 'success') {
      <section class="payment__panel" aria-labelledby="payment-success-title">
        <img
          class="payment__panel-mascot"
          src="/images/logo/charging.png"
          alt=""
          aria-hidden="true"
          loading="lazy"
          width="478"
          height="640"
        />
        <h1 id="payment-success-title" class="payment__title" tabindex="-1" data-phase-heading>
          {{ preCopy.successTitle }}
        </h1>
        <p class="payment__subtitle" role="status">{{ successMessage() }}</p>
        @if (isAuthenticated()) {
          <p class="payment__pp-hint">
            <app-pp-coin [size]="16" />
            <span>{{ ppHint }}</span>
          </p>
        }
        <div class="payment__actions">
          <app-button variant="primary" size="lg" (click)="browsePrepurchases()">
            {{ preCopy.successBrowse }}
          </app-button>
          <button type="button" class="payment__link" (click)="backToStore()">
            {{ preCopy.backToStore }}
          </button>
        </div>
      </section>
    } @else if (phase() === 'failed') {
      <section class="payment__panel payment__panel--error" aria-labelledby="payment-error-title">
        <img
          class="payment__panel-mascot"
          src="/images/logo/charging_error.png"
          alt=""
          aria-hidden="true"
          loading="lazy"
          width="640"
          height="626"
        />
        <h1 id="payment-error-title" class="payment__title" tabindex="-1" data-phase-heading>
          {{ cardCopy.errorTitle }}
        </h1>
        <p class="payment__error" role="alert">{{ errorMsg() }}</p>
        <p class="payment__reassurance">
          @if (canRetry()) {
            {{ cardCopy.reassureRetry }}
          } @else {
            {{ cardCopy.reassureBack }}
          }
        </p>
        <div class="payment__actions">
          @if (canRetry()) {
            <app-button variant="primary" size="lg" (click)="retry()">Reintentar</app-button>
          }
          <button type="button" class="payment__link" (click)="backToStore()">
            {{ preCopy.backToStore }}
          </button>
        </div>
      </section>
    } @else if (phase() === 'pending') {
      <section class="payment__panel" aria-labelledby="payment-pending-title">
        <h1 id="payment-pending-title" class="payment__title" tabindex="-1" data-phase-heading>
          {{ confirmingTitle() }}
        </h1>
        <p class="payment__subtitle">{{ confirmingBody() }}</p>
        @if (pollExhausted()) {
          <p class="payment__status" role="status" aria-live="polite" data-poll-exhausted>
            {{ preCopy.pollExhausted }}
          </p>
        }
        @if (errorMsg(); as msg) {
          <p class="payment__status" role="status" aria-live="polite">{{ msg }}</p>
        }
        <div class="payment__actions">
          <app-button
            variant="primary"
            size="lg"
            [disabled]="checking()"
            [loading]="checking()"
            (click)="checkSession()"
          >
            {{ preCopy.checkStatusCta }}
          </app-button>
          <button type="button" class="payment__link" (click)="backToStore()">
            {{ preCopy.backToStore }}
          </button>
        </div>
      </section>
    } @else {
      <!-- ready / confirming -->
      <div class="payment__layout">
        <aside class="payment__aside">
          <img
            class="payment__aside-mascot"
            src="/images/logo/charging.png"
            alt=""
            aria-hidden="true"
            loading="lazy"
            width="478"
            height="640"
          />
          <p class="payment__aside-tagline">
            La forma más perrona y segura de reservar tu precompra en Perrón Store
          </p>
        </aside>

        <div class="payment__main">
          <header class="payment__header">
            <h1 class="payment__title" tabindex="-1" data-phase-heading>{{ preCopy.payTitle }}</h1>
            <p class="payment__amount">
              {{ preCopy.amountLabel }}:
              <span class="payment__amount-value">{{ amountColones() | crc }}</span>
            </p>
            @if (isAuthenticated()) {
              <p class="payment__pp-hint">
                <app-pp-coin [size]="16" />
                <span>{{ ppHint }}</span>
              </p>
            }
            @if (expiresAt(); as exp) {
              <p class="payment__status" role="status" aria-live="polite">
                <app-countdown
                  [expiresAt]="exp"
                  [label]="timerLabel"
                  (expired)="onCountdownExpired()"
                />
              </p>
            }
          </header>

          <section class="payment__panel" aria-labelledby="payment-card-title">
            <h2 id="payment-card-title" class="payment__panel-title">Pago con tarjeta</h2>

            <div class="payment__card-mount" aria-live="polite">
              @if (!cardReady()) {
                <p class="payment__card-placeholder">Cargando el formulario de pago seguro…</p>
              }
              <div #paymentMount data-payment-mount></div>
            </div>

            @if (phase() === 'confirming') {
              <p class="payment__status" role="status" aria-live="polite">Procesando tu pago…</p>
            }

            <div class="payment__actions">
              <app-button
                variant="primary"
                size="lg"
                [disabled]="!cardReady() || submitting()"
                [loading]="submitting()"
                (click)="onPayClick()"
              >
                Pagar {{ amountColones() | crc }}
              </app-button>
              <button type="button" class="payment__link" (click)="backToStore()">
                {{ preCopy.backToStore }}
              </button>
            </div>
          </section>
        </div>
      </div>
    }
  </div>
</main>
